'use client';
/* eslint-disable tailwindcss/no-arbitrary-value -- the content width is a token reached as a CSS variable */

import Button from '../../../components/Button';
import type { VerticalType } from '../../../types/cmsTypes';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { compareVariantCopy, compareVariantOf } from '../compareVariant';
import { TRANSLATIONS } from '../i18n';

/**
 * What a vertical that prompts (rather than returning to its results page) shows a reader who
 * reaches the comparison with nothing selected: never an empty table.
 */
export const CompareEmptyState = ({
  browseHref,
  vertical,
}: {
  browseHref: string;
  vertical: VerticalType;
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);
  const variant = compareVariantOf(vertical);
  if (!variant) return null;
  const copy = compareVariantCopy(variant, staticText);

  return (
    <div
      data-component="compare-empty-state"
      className="mx-auto flex w-full max-w-[--breakpoints-content-narrow-3-lg] flex-col items-center gap-4 px-4 py-16 text-center"
    >
      <h1 className="mhg-alpha-typography-title-2 text-text/primary">
        {copy.emptyTitle}
      </h1>
      <Button
        as="a"
        // Internal navigation: not `FeLink`, which treats an href containing "ad" as an advert.
        href={browseHref}
        size="small"
        styleType="primary"
      >
        {copy.emptyAction}
      </Button>
    </div>
  );
};
